// Sentry must be initialized before any other imports
import "./instrument";

import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import App from "./App.tsx";
import "./index.css";
import { initI18n, fetchAndApplyOverrides } from "@/i18n";

// CST207 boot order (deterministic, not Suspense-gated):
//   1. await i18n.init()
//   2. raw fetch of /api/i18n/overrides (no React Query — no provider mounted yet, ADR-2)
//   3. merge overrides via addResourceBundle, seed window.__I18N_BOOT_OVERRIDES__
//   4. createRoot + render
// Top-level await requires vite build.target >= es2022 and tsconfig target >= ES2022.
const i18nInstance = await initI18n();
window.__I18N_BOOT_OVERRIDES__ =
  (await fetchAndApplyOverrides(i18nInstance)) ?? undefined;

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);
